/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetDevelopmentDatabaseInfoResponse,
  PingResponse
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const ping = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PingResponse>(
      {url: `/api/ping`, method: 'GET', signal
    },
      );
    }
  



export const getPingQueryKey = () => {
    return [
    `/api/ping`
    ] as const;
    }

    
export const getPingQueryOptions = <TData = Awaited<ReturnType<typeof ping>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ping>>> = ({ signal }) => ping(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PingQueryResult = NonNullable<Awaited<ReturnType<typeof ping>>>
export type PingQueryError = ErrorType<unknown>


export function usePing<TData = Awaited<ReturnType<typeof ping>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ping>>,
          TError,
          Awaited<ReturnType<typeof ping>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePing<TData = Awaited<ReturnType<typeof ping>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ping>>,
          TError,
          Awaited<ReturnType<typeof ping>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePing<TData = Awaited<ReturnType<typeof ping>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePing<TData = Awaited<ReturnType<typeof ping>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ping>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDevelopmentDatabaseInfo = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetDevelopmentDatabaseInfoResponse>(
      {url: `/api/ping/development/database`, method: 'GET', signal
    },
      );
    }
  



export const getGetDevelopmentDatabaseInfoQueryKey = () => {
    return [
    `/api/ping/development/database`
    ] as const;
    }

    
export const getGetDevelopmentDatabaseInfoQueryOptions = <TData = Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevelopmentDatabaseInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>> = ({ signal }) => getDevelopmentDatabaseInfo(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevelopmentDatabaseInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>>
export type GetDevelopmentDatabaseInfoQueryError = ErrorType<unknown>


export function useGetDevelopmentDatabaseInfo<TData = Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>,
          TError,
          Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevelopmentDatabaseInfo<TData = Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>,
          TError,
          Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevelopmentDatabaseInfo<TData = Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDevelopmentDatabaseInfo<TData = Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevelopmentDatabaseInfo>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevelopmentDatabaseInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




